<template>
  <div class="images-wrap">
    <ul class="image-list">
      <li
        v-for="(image, index) in imagesList"
        :key="index"
        class="image-list__item"
      >
        <el-image
          :src="image.url"
          :preview-src-list="image.srcList"
          fit="contain"
          referrerpolicy="no-referrer"
        >
        </el-image>
      </li>
    </ul>

  </div>
</template>

<script>
  export default {
    name: 'Gallery',
    props: {
      images: {
        type: Array
      }
    },
    computed: {
      imagesList() {
        return this.images.map(item => {
          return {
            url: item.url,
            srcList: this.images.map(item => item.url),
          };
        });
      },
    },
  };
</script>

<style>
  .images-wrap {

    margin-bottom: -20px;
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    /*padding: 15px 20px 10px 73px;*/
    padding: 10px 0;
  }
  .image-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
  }
  .image-list__item {
    margin-right: 5px;
    width: 100px;
  }
  @media screen and (max-width: 480px) {
    .image-list__item{
        width: 60px;
    }
    .images-wrap {
      padding: 0;
    }
    .el-image{
      width: 60px!important;
    }
  }
</style>
